import { render, staticRenderFns } from "./DeviceNotifyList_v3.vue?vue&type=template&id=53ea0b97&scoped=true&"
import script from "./DeviceNotifyList_v3.vue?vue&type=script&lang=js&"
export * from "./DeviceNotifyList_v3.vue?vue&type=script&lang=js&"
import style0 from "./DeviceNotifyList_v3.vue?vue&type=style&index=0&id=53ea0b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea0b97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VAppBar,VBtn,VContainer,VContent,VIcon,VToolbarTitle})
